/* eslint-disable max-len */

var UI_PHOTO_NARROW = {
  "default": 'M7.19,14.85a3.52,3.52,0,1,0-3.51-3.51A3.52,3.52,0,0,0,7.19,14.85Zm0-5a1.52,1.52,0,1,1-1.51,1.52A1.52,1.52,0,0,1,7.19,9.82Zm24.52-5A1.05,1.05,0,0,0,31,4.5H1a1.05,1.05,0,0,0-.71.29A1.05,1.05,0,0,0,0,5.5v21a1.05,1.05,0,0,0,.29.71A1.05,1.05,0,0,0,1,27.5H31a1,1,0,0,0,1-1V5.5A1.05,1.05,0,0,0,31.71,4.79ZM30,25.5H21.57l-5.13-3.94,7.19-6.92L30,20.3Zm0-19V17.62l-5.73-5.09a1,1,0,0,0-1.36,0l-8.07,7.76L10,16.62a1,1,0,0,0-1.21,0L2,21.75V6.5ZM2,24.26l7.4-5.59,8.89,6.83H2Z'
};

export { UI_PHOTO_NARROW };
//# sourceMappingURL=UI_PHOTO_NARROW.js.map
